import { render, staticRenderFns } from "./LotteriesWeek.vue?vue&type=template&id=33d8f3ff&"
import script from "./LotteriesWeek.vue?vue&type=script&lang=js&"
export * from "./LotteriesWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports